import { render, staticRenderFns } from "./FooterThree.vue?vue&type=template&id=bd3a398c&"
import script from "./FooterThree.vue?vue&type=script&lang=js&"
export * from "./FooterThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports